import TextInputElement from "../../../components/inputs/TextInputElement";

interface SearchBoxProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  compact?: boolean;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  searchTerm,
  onSearchChange,
  compact = false,
}) => {
  if (compact) {
    return (
      <div className="flex flex-col space-y-2">
        <div className="font-bold text-[16px] leading-[20px]">
          Cerca
        </div>
        <div className="flex-1">
          <TextInputElement
            label={"search-input"}
            placeholder={"Nome, Cognome, E-mail o Codice"}
            inputValue={searchTerm}
            onChange={onSearchChange}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full rounded-[5px] shadow-platform px-[20px] py-[30px]">
      <div className="w-full h-full flex justify-between items-center">
        <div className="w-full h-full flex flex-col">
          <div className="font-bold text-[20px] leading-[33px]">
            Cerca
          </div>
          <div className="w-full">
            <TextInputElement
              label={"search-input"}
              placeholder={"Cerca per Nome, Cognome, E-mail o Codice identificativo"}
              inputValue={searchTerm}
              onChange={onSearchChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}; 